import { PaymentEnum } from '../shared/enum/payment.enum';
import { initialPhonePrefixState, PhonePrefixState } from './phone-prefix.store';

export type DirectDebitState = {
  periodicity: string;
  start_date: string | Date | null;
  debit_day: string;
  iban: string;
  account_owner: boolean | null;
  phone_prefix: PhonePrefixState;
};

export const initialDirectDebitState: DirectDebitState = {
  periodicity: PaymentEnum.Mensuel,
  start_date: '',
  debit_day: '',
  iban: '',
  account_owner: null,
  phone_prefix: initialPhonePrefixState
};
